import { useMemo } from "react";
import { View } from "react-native";

import { useTheme } from "../../utils/theme";
import { Typography } from "../Typography";

import type { ReactNode } from "react";
import type { ViewProps } from "react-native";
export interface AssistiveTextProps extends ViewProps {
  children: string | ReactNode;
  status?: "gray" | "info" | "success" | "warning" | "error";
  floating?: boolean;
}

export function AssistiveText({
  style,
  status = "gray",
  floating = true,
  children,
}: AssistiveTextProps) {
  const { colors, spacing, rounding } = useTheme();

  const colorStyles = useMemo(() => {
    const backgroundColor = colors.backgroundMuted;

    return {
      gray: {
        backgroundColor,
        color: colors.textBody,
      },
      info: {
        backgroundColor,
        color: colors.infoText,
      },
      success: {
        backgroundColor,
        color: colors.successText,
      },
      warning: {
        backgroundColor,
        color: colors.warningText,
      },
      error: {
        backgroundColor,
        color: colors.errorText,
      },
    };
  }, [
    colors.backgroundMuted,
    colors.errorText,
    colors.infoText,
    colors.successText,
    colors.textBody,
    colors.warningText,
  ]);

  return (
    <View
      style={[
        {
          backgroundColor: colorStyles[status].backgroundColor,
          paddingHorizontal: spacing.md,
          paddingVertical: spacing.xs,
          marginBottom: 2,
          borderRadius: rounding.md,
          borderBottomLeftRadius: floating ? rounding.md : rounding.sm,
          borderBottomRightRadius: floating ? rounding.md : rounding.sm,
        },
        style,
      ]}
    >
      {typeof children === "string" ? (
        <Typography
          variation="regular.caption.medium"
          style={{ color: colorStyles[status].color }}
          focusable={true}
        >
          {children}
        </Typography>
      ) : (
        children
      )}
    </View>
  );
}
